<template >
    <!-- <div class="container"> -->
        <div class="error-main">
            <div class="error-heading">
                <img :src="logo" />
            </div>
            <p>Bạn không có quyền truy cập tính năng này. Liên hệ với Admin của bạn hoặc thử truy cập bằng tài khoản khác.</p>
            <Button label="Đăng xuất ngay" @click="displayLogout = true" class="main-style-button" />
            <Dialog header="ĐĂNG XUẤT" :visible.sync="displayLogout" :style="{width: '600px','text-align': 'left'}" :modal="true" position="top">
              <div class="confirmation-content">
                  <span>Bạn có chắc muốn đăng xuất khỏi tài khoản này không?</span>
              </div>
              <template #footer>
                <div class="custom-center">
                  <Button label="Hủy" @click="displayLogout = false" icon="pi pi-times" class="btn-cancel" />
                  <Button label="Xác nhận" @click="validateLogout()" icon="pi pi-check" class="btn-save mr-0" autofocus="autofocus" />
                  <!-- <button @click="closeLogout()" class="btn btn-cancel"> Huỷ</button>
                  <button @click="validateLogout()" class="btn btn-save mr-0" autofocus><i class="pi pi-check icon" style="font-size: 15px; "></i> Xác nhận</button>  -->
                </div>
              </template>
            </Dialog>
        </div>
    <!-- </div> -->
  </template>
  <script>
export default {
  data() {
    return {
      displayLogout: false
    }
  },
  computed: {
    logo() {
      return "../../../../assets/images/icon/lock.png";
    }
  },
  mounted() {
    // document.body.style.zoom = "100%"; //zoom web lại 80%
    var open = localStorage.getItem("isOpen");
    if (open === undefined || !open) {
      this.staticMenuInactive = false;
    } else {
      this.staticMenuInactive = true;
    }
  },
  methods: {
    validateLogout() {
      // console.log('Logout')
      this.$AuthenticationApp.clearDataLogout().then(() => {
        //this.$emit('close')
        this.displayLogout = false;
        //this.$router.push('/auth/login')
      })
    }
  }
}
</script>
<style>
  /* body{
    font-family: 'Ropa Sans', sans-serif;
    margin-top: 30px;
    background-color: #F3F4F7;
    text-align: center;
    color: #fff;
  } */
  .error-heading{
    margin: 0px auto;
    width: 250px;
    border: 5px solid #fff;
    font-size: 126px;
    line-height: 126px;
    border-radius: 30px;
    text-shadow: 6px 6px 5px #000;
  }
  .error-heading img{
    width: 100%;
  }
  .error-main h1{
    font-size: 72px;
    margin: 0px;
    color: #F3661C;
    text-shadow: 0px 0px 5px #fff;
  }
  .error-main {
    width: 600px;
    text-align: center;
    margin: 50px auto;
    background-color: #fff;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0px 3px 6px #00000029;
    p {
      color: #666666;
    }
  }
  
</style>